import React from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";

import { actions as rootActions } from "../actions";
import { NAME as COMPANIES_NAME } from "../reducer";
import SearchedTable from "../../../components/SearchedTable";
import Statistic from "../components/Statistic";
import { hasProduct } from "../productFilter";
import LoadError from "../../../components/LoadError";
import CircularProgress from "@material-ui/core/CircularProgress";
import Paper from "@material-ui/core/Paper";
import Typography from "@material-ui/core/Typography";

function mapStateToProps(state) {
  return {
    ...state[COMPANIES_NAME],
  };
}

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      ...rootActions,
    },
    dispatch
  );

class Root extends React.Component {
  constructor(props) {
    super(props);
    // Выбранный товар: '' значит все товары. Он же отбирает строки таблицы.
    this.state = { selectedProduct: "" };
    //props.getCompaniesList()
    props.margeProductsToCompany();
  }
  componentDidMount() {
    console.log("CERF");
    // Log tableColumns and tableData to check their values
    console.log("this.props.tableColumns");
    console.log(this.props.tableColumns);
    console.log("this.props.tableData");
    console.log(this.props.tableData);
    console.log("this.props.productTypes");
    console.log(this.props.productTypes);
    
  }
  componentDidUpdate(prevProps) {
    if (prevProps.tableColumns !== this.props.tableColumns || prevProps.tableData !== this.props.tableData) {
      console.log("Updated tableColumns");
      console.log(this.props.tableColumns);
      console.log("Updated tableData");
      console.log(this.props.tableData);
      console.log("Updated productTypes");
    console.log(this.props.productTypes);
    }
  }
  render() {
    if (this.props.listError) {
      return <LoadError onRetry={this.props.margeProductsToCompany} />;
    }
    // Первая загрузка: данных ещё нет, пустая таблица была бы похожа на «компаний нет».
    if (this.props.listLoading && this.props.tableData.length === 0) {
      return (
        <Paper style={{ padding: "32px 24px", textAlign: "center" }}>
          <CircularProgress size={28} />
          <Typography variant="body2" color="textSecondary" style={{ marginTop: 12 }}>
            Загрузка…
          </Typography>
        </Paper>
      );
    }
    const { selectedProduct } = this.state;
    const rows = selectedProduct
      ? this.props.tableData.filter((company) => hasProduct(company, selectedProduct))
      : this.props.tableData;
    return (
      <>
        <Statistic
          selectedProduct={selectedProduct}
          onProductChange={(product) => this.setState({ selectedProduct: product })}
          tableDescription = {{
            columns: this.props.aditionalTableColumns,
            data: this.props.tableData,
            productTypes: this.props.productTypes
          }}
        />
        <SearchedTable
          tableTitle="Список компаний"
          rowHint={(row) => {
            // Вторая колонка — isProcesed напоминания: из-за неё строка бежевая.
            if (row[1] === null || row[1] === undefined || row[1] === "") return "Напоминание не настроено";
            if (Number(row[1]) === 0) return "Сработало напоминание: пора связаться с компанией";
            return null;
          }}
          sortOrder={{
            name: "isProcesed",
            direction: "asc",
          }}
          tableDescription={{
            columns: this.props.tableColumns,
            data: rows,
          }}
          clickAction={(rowData, rowMeta) => {
            let id = rowData[0];
            this.props.setCurrentCompany(id);
          }}
        />
      </>
    );
  }
}
export default connect(mapStateToProps, mapDispatchToProps)(Root);
